import React from "react";
import { FaFingerprint } from "react-icons/fa";
import { Tab, Nav } from "react-bootstrap";
import { BsFillPlayFill, BsPauseFill } from "react-icons/bs";
import { useRef, useState } from "react";
import ButtonList from "../ButtonList/ButtonList";
import { Link } from "react-router-dom";

import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { BsChevronDown } from "react-icons/bs";

import axios from 'axios';
import { API_URL } from "../../Api/config";


import GrassClipping from "../../assets/images/arizona/grassClippings.png";
import RangePerformance from "../../assets/images/arizona/rangePerformance.png";
import Popuplogo from "../../assets/images/logo_icon.png";

import { IoClose } from "react-icons/io5";


function EventList() {

    const playerRefs = useRef([]);
    const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);
    const [formId, setFormId] = useState(null);


    const [showform, setShowform] = useState(false);

    const handleCloseForm = () => setShowform(false);
    const handleShowForm = (formid) => {
        setFormId(formid);
        setShowform(true);
    };

    const [validated, setValidated] = useState(false);
    const [fName, setFName] = useState('');
    const [lName, setLName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [dexterity, setDexterity] = useState('');
    const [preferredDate, setPreferredDate] = useState('');
    const [preferredTime, setPreferredTime] = useState('');
    const [description, setDescription] = useState('');
    const [apicall, setApicall] = useState(false);
    const [serverSideError, setServerSideError] = useState(null);

    const timeArray = [
        "Morning", "Afternoon", "Evening"
    ];

    const dateArray = [
        "December 7th", "December 8th", "December 9th", "December 10th", "December 11th", "December 12th"
    ];

    const dexterityArray = [
        "Left", "Right"
    ];

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleSubmit = (event) => {


        event.preventDefault(); // Prevent form from submitting the default way

        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.stopPropagation(); // Stop further event propagation if form is invalid
            setValidated(true); // Set form validation state
        } else {
            setApicall(true); // Indicate API call in progress

            // Your form submission logic here
            const data = {
                firstName: fName,
                lastName: lName,
                phoneNumber: phone,
                email: email,
                description: description,
                preferredtime: timeArray[preferredTime],
                date: dateArray[preferredDate],
                dexterity: dexterityArray[dexterity],
                subject: "grassy", // Hardcoded subject for this context
                formid: formId
            };

            axios.post(API_URL + 'contact/submit-event', data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    console.log("response", response);
                    handleCloseForm();
                    handleShow(); // Show confirmation/modal on success

                    // Reset form fields
                    setFName('');
                    setLName('');
                    setPhone('');
                    setEmail('');
                    setDescription('');
                    setServerSideError(null); // Clear server-side error if successful
                })
                .catch(error => {
                    console.error("error", error);
                    // Set the server-side error message
                    setServerSideError(error.response?.data || "An error occurred. Please try again.");
                })
                .finally(() => {
                    setApicall(false); // Reset API call state
                    setValidated(false); // Reset form validation state
                });
        }

        setValidated(true); // Set form validation state
    };

    return (
        <>

            <Modal
                show={show}
                onHide={handleClose}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="custom-modal-header">
                        <div className="logo-modal">
                            <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                        </div>
                        <div className="close-modal">
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"> <IoClose /></button>
                        </div>
                    </div>
                    <div className='modal-image'>
                        <img src={require('../../assets/images/forewardFormSubmit.png')} alt="logo" />
                    </div>
                    <h3 className="text-center mb-4">
                        Your message is sent!
                    </h3>
                    <p className="text-center mb-0">
                        Our staff will be in contact shortly to answer any questions and get you sorted.
                    </p>
                </Modal.Body>
            </Modal>

            <section id="our_process" className="our_process bg_dark page-section bg_img pb-0">
                <div className="container-xl">

                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                        {/* <Nav variant="pills" className="nav nav-tabs process_tabs our_services_tabs hide_desktop">
                            <Nav.Item className="">
                                <Nav.Link eventKey="first" className="">
                                    Range Performance
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item className="">
                                <Nav.Link eventKey="second" className="">
                                    Grass Clippings
                                </Nav.Link>
                            </Nav.Item>
                        </Nav> */}

                        <>
                            <Tab.Content className="row" id="Process_tab_Content">
                                {/* <Tab.Pane eventKey="first" className="tab-pane fade show_desktop col-lg-6">
                                    <div className="pr_card card-radius card-dark bg_dark_black">
                                        <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                                            <div id="player" className="v-video video-image-div">
                                                <img src={RangePerformance} />
                                            </div>
                                        </div>
                                        <div class="pr_content1 mb-0 mt-2">
                                            <div class=" ">
                                                <div class="form-element-event-list mb-5 mt-5">
                                                    <h2 style={{ "color": "rgb(255, 255, 255)", "font-weight": "bold" }}>Location:</h2>
                                                    <p style={{ "color": "rgb(255, 255, 255)" }}>Range Performance</p>
                                                    <h2 style={{ "color": "rgb(255, 255, 255)" }}>Address:</h2>
                                                    <p style={{ "color": "rgb(255, 255, 255)" }}>7625 E Redfield Rd #145 <br /> Scottsdale, AZ 85260</p>
                                                    <h2 style={{ "color": "rgb(255, 255, 255)" }}>When:</h2>
                                                    <p style={{ "color": "rgb(255, 255, 255)" }}>October 24th from 9 to 5
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-md-12 text-center"><button class="Login-btn-view btn btn-primary" onClick={
                                                () => {
                                                    handleShowForm("range-perfomance");
                                                }
                                            }><span>Reserve your spot</span></button></div>
                                        </div>
                                    </div>
                                </Tab.Pane> */}
                                <div className="d-flex justify-content-center overflow-visible-container">
                                    <Tab.Pane eventKey="first" className="tab-pane fade show_desktop col-lg-6">
                                        <div className="" role="tabpane2" aria-labelledby="second-tab">
                                            <div className="pr_card card-radius card-dark bg_dark_black">
                                                <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                                                    <div id="player" className="v-video video-image-div">
                                                        <img src={GrassClipping} />
                                                    </div>
                                                </div>
                                                <div class="pr_content1 mb-0 mt-2">
                                                    <div class=" ">
                                                        <div class="form-element-event-list mb-5 mt-5">
                                                            <h2 style={{ "color": "rgb(255, 255, 255)", "font-weight": "bold" }}>Location:</h2>
                                                            <p style={{ "color": "rgb(255, 255, 255)" }}>Grass Clippings Rolling Hills</p>
                                                            <h2 style={{ "color": "rgb(255, 255, 255)" }}>Address:</h2>
                                                            <p style={{ "color": "rgb(255, 255, 255)" }}>1415 N Mill Ave <br /> Tempe, AZ 85288</p>
                                                            <h2 style={{ "color": "rgb(255, 255, 255)" }}>When:</h2>
                                                            <p style={{ "color": "rgb(255, 255, 255)" }}>December 7th-12th<br/> 8am to 4pm</p>
                                                            

                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 text-center"><button class="Login-btn-view btn btn-primary" onClick={
                                                        () => {
                                                            handleShowForm("grass-clippings");
                                                        }
                                                    }><span>Reserve your spot</span></button></div>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                </div>
                            </Tab.Content>
                        </>
                    </Tab.Container>
                </div>
            </section>


            <Modal size="lg" centered show={showform} onHide={handleCloseForm} className="card-radius popup-modal-dark">

                <Modal.Header className="custom-modal-header custom-modal-header-event">
                    <div className="modal-nav">
                        <div className="modal-logo">
                            <img src={Popuplogo} alt="logo" />
                        </div>
                    </div>
                    <div className="close-modal">
                        <button type="button" className="btn-close" onClick={handleCloseForm} aria-label="Close"> <IoClose /></button>
                    </div>
                </Modal.Header>
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">


                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                        <div className="row gx-2">
                            <div className="col-md-6 form-group" controlid="validationCustom01">
                                <input
                                    type="text"
                                    name="f-name"
                                    className="form-control dashboard-input-box-3"
                                    placeholder="First name"
                                    value={fName}
                                    onChange={(e) => setFName(e.target.value)}
                                    required
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please enter a first name.
                                </Form.Control.Feedback>
                            </div>

                            <div className="col-md-6 form-group" controlid="validationCustom02">
                                <input
                                    type="text"
                                    name="l-name"
                                    className="form-control dashboard-input-box-3"
                                    placeholder="Last name"
                                    value={lName}
                                    onChange={(e) => setLName(e.target.value)}
                                    required
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please enter a last name.
                                </Form.Control.Feedback>
                            </div>

                            <div className="col-md-12 form-group" controlid="validationCustom03">
                                <input
                                    type="tel"
                                    name="phone"
                                    pattern="[0-9]{8,}"
                                    title="Please enter an 8-digit phone number."
                                    className="form-control dashboard-input-box-3"
                                    placeholder="Phone"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value.replace(/[^0-9]/g, ''))}
                                    required
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please enter a valid phone number.
                                </Form.Control.Feedback>
                            </div>

                            <div className="col-md-12 form-group" controlid="validationCustom04">
                                <input
                                    type="email"
                                    className="form-control dashboard-input-box-3"
                                    name="email"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please enter a valid email.
                                </Form.Control.Feedback>
                            </div>

                            <div className="col-md-12 form-group select-box-arrow">
                                <select
                                    className="form-control dashboard-input-box-3"
                                    name="dexterity"
                                    value={dexterity}
                                    onChange={(e) => setDexterity(e.target.value)}
                                    required
                                >
                                    <option value="">Dexterity</option>
                                    <option value="0">Left</option>
                                    <option value="1">Right</option>
                                </select>
                                <BsChevronDown />
                                <Form.Control.Feedback type="invalid">
                                    Please select dexterity.
                                </Form.Control.Feedback>
                            </div>

                            <div className="col-md-6 form-group select-box-arrow">
                                <select
                                    className="form-control dashboard-input-box-3"
                                    name="preferredDate"
                                    value={preferredDate}
                                    onChange={(e) => setPreferredDate(e.target.value)}
                                    required
                                >
                                    <option value="">Preferred Date</option>
                                    <option value="0">December 7th</option>
                                    <option value="1">December 8th</option>
                                    <option value="2">December 9th</option>
                                    <option value="3">December 10th</option>
                                    <option value="4">December 11th</option>
                                    <option value="5">December 12th</option>
                                </select>
                                <BsChevronDown />
                                <Form.Control.Feedback type="invalid">
                                    Please select a preferred time.
                                </Form.Control.Feedback>
                            </div>

                            <div className="col-md-6 form-group select-box-arrow">
                                <select
                                    className="form-control dashboard-input-box-3"
                                    name="preferredTime"
                                    value={preferredTime}
                                    onChange={(e) => setPreferredTime(e.target.value)}
                                    required
                                >
                                    <option value="">Preferred Time</option>
                                    <option value="0">Morning</option>
                                    <option value="1">Afternoon</option>
                                    <option value="2">Evening</option>
                                </select>
                                <BsChevronDown />
                                <Form.Control.Feedback type="invalid">
                                    Please select a preferred time.
                                </Form.Control.Feedback>
                            </div>

                            <div className="col-md-12 form-group">
                                <textarea
                                    className="form-control dashboard-input-box-3"
                                    name="message"
                                    placeholder="Anything you want us to know?"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    rows={5}
                                    required
                                ></textarea>
                            </div>

                            <div className="col-md-12 text-center">
                                <Button className="btn btn-dark btn-block form-btn form-btn-request-submit" type="submit">
                                    {apicall ? <Spinner animation="grow" variant="light" /> : <span>Request your fitting</span>}
                                </Button>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
                <style>
                    {`
                        section#our_process{
                            overflow: visible !important;
                        }
                        section#our_process .overflow-visible-container{
                            margin-top: -11rem !important;
                        }
                    `}
                </style>
        </>
    );
}

export default EventList;